module.exports = __webpack_public_path__ + "img/lower_ruffle_lenght.81440208.png";